import { useEffect, useState } from 'react';
import { Badge, IconButton, Tooltip } from '@material-ui/core';
import { PermMedia } from '@material-ui/icons';
import UploaderModal from './UploaderModal';
import DialogComp from '../Modal/dialogModal';

const FileUploaderButton = ({ fileCount, recordId, fileUploaderConfigName, showToastRef, gridRelaod, fileUploaderModalClose, docIDPassed, hideBadge }) => {
    const [state, setState] = useState({
        showUploader: false,
        recordId,
        fileCount: `${fileCount || 0}`,
        configName: fileUploaderConfigName
    });

    useEffect(() => {
        if (fileCount !== undefined && fileCount !== null) {
            setState((st) => ({
                ...st,
                fileCount: `${fileCount || 0}`
            }));
        }
    }, [fileCount]);

    const hideFileUploader = (res) => {
        setState((st) => ({ ...st, showUploader: false }));
        res && gridRelaod();
    };

    const showFileUploader = () => {
        setState((st) => ({ ...st, showUploader: true }));
    };

    return (
        <>
            {hideBadge ? (
                <IconButton title={`Document Manager`} size="small">
                    <PermMedia style={{ fontSize: 20, cursor: 'pointer' }} onClick={showFileUploader} />
                </IconButton>
            ) : (
                <Badge className="file-upload-badge" badgeContent={state.fileCount} color="secondary" max={999} showZero>
                    <PermMedia style={{ fontSize: 20, cursor: 'pointer' }} color="secondary" onClick={showFileUploader} />
                </Badge>
            )}

            {state.showUploader && (
                <DialogComp title="Document Manager" onClose={() => hideFileUploader(false)} maxWidth="xl">
                    <UploaderModal
                        recordId={recordId}
                        configName={fileUploaderConfigName}
                        showToastRef={showToastRef}
                        gridRelaod={gridRelaod}
                        fileUploaderModalClose={fileUploaderModalClose || false}
                        onClose={hideFileUploader}
                        docIDPassed={docIDPassed}
                    />
                </DialogComp>
            )}
        </>
    );
};

export default FileUploaderButton;
